import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/copy';
export function Audience() {
  return <section aria-labelledby="para-quien" className="w-full border-y border-sand bg-white" data-id="element-6" data-mp="3p1x9uy7gfspq">
      <div className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-7" data-mp="6warwb6p3ii5">
        <h2 id="para-quien" className="font-display text-[1.6rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.5rem]" data-id="element-8" data-mp="1uv5aeovd3xn">
          ¿Es esto para ti?
        </h2>

        <div className="mt-6 grid gap-7 sm:mt-10 md:grid-cols-2 md:gap-14" data-id="element-9" data-mp="bt158qr47zzv">
          <div data-id="element-10" data-mp="plh197llmxra">
            <h3 className="border-b border-sand pb-3 text-base font-semibold text-ink" data-id="element-11" data-mp="pk60zhrd484x">
              Sí, si eres de las que…
            </h3>
            <ul className="mt-4 space-y-3 sm:mt-5 sm:space-y-4" data-id="element-12" data-mp="llzved29fyll">
              {forYou.map(item => <li key={item} className="flex gap-2.5 text-[0.95rem] leading-relaxed text-muted sm:gap-3 sm:text-base" data-id="element-13" data-mp="zh2clwck5adp">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark sm:h-5 sm:w-5" strokeWidth={3} aria-hidden="true" data-id="element-14" data-mp="16esw6viddm5c" />
                  <span data-id="element-15" data-mp="1gd8q168s79ij">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-16" data-mp="1kamzmz0djjb2">
            <h3 className="border-b border-sand pb-3 text-base font-semibold text-ink" data-id="element-17" data-mp="1pbu4oqb4u4e1">
              No, si buscas…
            </h3>
            <ul className="mt-4 space-y-3 sm:mt-5 sm:space-y-4" data-id="element-18" data-mp="1u9vo5cch05q1">
              {notForYou.map(item => <li key={item} className="flex gap-2.5 text-[0.95rem] leading-relaxed text-muted sm:gap-3 sm:text-base" data-id="element-19" data-mp="1z2ykfs8mtt9x">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-alert sm:h-5 sm:w-5" strokeWidth={3} aria-hidden="true" data-id="element-20" data-mp="282tx61hu5wc2" />
                  <span data-id="element-21" data-mp="cyniks9fcqy1">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}